import { Box, Button, Chip, Icon, Stack, Typography } from "@mui/material";
import ContractAcceptance from "./Acceptance";

export default function ContractDocument({
  contract,
  required = false,
  accepted = false,
  onAccepted,
  onReload,
}) {
  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            width: 56,
            height: 56,
            flexShrink: 0,
            borderRadius: 3,
            bgcolor: "#e9f7ed",
            color: "#138735",
          }}
        >
          <Icon fontSize="large">description</Icon>
        </Box>
        <Box>
          <Typography variant="overline" color="text.secondary">
            DOCUMENTOS DA PLATAFORMA
          </Typography>
          <Typography variant="h4">
            {contract.isDemo ? "Contrato de uso da plataforma" : contract.title}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Chip size="small" label={`Versão ${contract.versionId}`} />
        <Chip
          size="small"
          variant="outlined"
          label={`Publicado em ${new Date(contract.publishedAt).toLocaleDateString("pt-BR")}`}
        />
        {accepted && <Chip size="small" color="success" label="Aceite registrado" />}
      </Stack>
      <Typography variant="body2" color="text.secondary">
        Leia o contrato completo abaixo. Você também pode abrir o PDF em outra aba para consultar ou
        salvar uma cópia.
      </Typography>
      <Box
        sx={{
          border: "1px solid #dde5df",
          borderRadius: 3,
          overflow: "hidden",
          bgcolor: "#edf1ee",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2, bgcolor: "#f7faf8", borderBottom: "1px solid #dde5df" }}
        >
          <Typography variant="button">Contrato completo · PDF</Typography>
          <Button
            component="a"
            href={contract.viewerUrl || contract.pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<Icon>open_in_new</Icon>}
          >
            Abrir PDF
          </Button>
        </Stack>
        <Box
          component="iframe"
          title="Contrato da plataforma em PDF"
          src={contract.pdfUrl}
          sx={{ display: "block", width: "100%", height: "65vh", minHeight: 360, border: 0 }}
        />
      </Box>
      {required && (
        <Box sx={{ pt: 1 }}>
          <Typography variant="h6" mb={2}>
            Confirme seu aceite para continuar
          </Typography>
          <ContractAcceptance
            key={contract.versionId}
            contract={contract}
            onAccepted={onAccepted}
            onReload={onReload}
          />
        </Box>
      )}
    </Stack>
  );
}
